module.exports = __webpack_public_path__ + "static/img/mobile-rank-bg.4569108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-rank-bg.png
// module id = z4RY
// module chunks = 1